<script>
import Drawer from "@/components/drawer.vue";
import Swal from "sweetalert2";
// Custom Components
import PageHeader from "@/components/page-header";
import CdxUserDetails from "@/components/superAdmin/user/cdxUserForm.vue";
import superService from "@/helpers/APIService/super.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import appConfig from "@/app.config";

export default {
  page: {
    title: "User list",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Drawer,
    CdxUserDetails,
    PageHeader,
  },
  data() {
    return {
      title: "Support Admin",
      userdata: [],
      dataId: "",
      isShowUserForm: false,
      selectedUser: null,
      isLoading: false,
      isEdit: false,
      isPasswordShow: false,
    };
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    // Method is used to get hotel list
    async getUsers() {
      this.isLoading = true;
      try {
        const response = await superService.getCdxUserList();
        if (response) {
          this.userdata = response;
          this.isLoading = false;
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to update user details
    updateCdxUserDetail(user) {
      this.isEdit = true;
      this.selectedUser = user;
      this.isShowUserForm = !this.isShowUserForm;
    },
    // Method is used to handle PBX form
    UserForm() {
      this.isEdit = false;
      this.selectedUser = null;
      this.isShowUserForm = !this.isShowUserForm;
    },
    // Method is used to handle hotel submission
    handleUserSubmit(data) {
      if (this.isEdit) {
        this.userdata = this.userdata.map((item) => {
          if (item.id == data.id) {
            item = data;
          }
          return item;
        });
      } else {
        this.userdata.push(data);
      }
      this.UserForm();
    },
    // Method is used to delete user
    deleteCdxUser(id, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          superService
            .deleteCdxUser(id)
            .then(() => {
              Middleware.notification("User deleted !!", "success");
              this.userdata.splice(index, 1);
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    // Method is used to handle user status change
    statusChange(id, data) {
      superService
        .editCdxUser(id, data)
        .then((response) => {
          Middleware.notification("Status change successfully !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
  },
};
</script>
<template>
  <div>
    <PageHeader
      :title="title"
      :action="UserForm"
      text="Add New User"
      :isButton="true"
    />
    <b-card>
      <div class="table-responsive">
        <table class="table mb-0">
          <thead class="table-light">
            <tr>
              <th>E-mail</th>
              <th>First Name</th>
              <th>last Name</th>
              <th>Mobile No</th>
              <th>User Hotel</th>
              <th>Active</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody v-if="isLoading">
            <tr v-for="item in 10" :key="item">
              <td class="placeholder-glow" v-for="no in 7" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="(user, index) in userdata" :key="index">
              <td @click="updateCdxUserDetail(user)">
                {{ user.email ? user.email : "-" }}
              </td>
              <td @click="updateCdxUserDetail(user)">
                {{ user.first_name ? user.first_name : "--" }}
              </td>
              <td @click="updateCdxUserDetail(user)">
                {{ user.last_name ? user.last_name : "--" }}
              </td>
              <td @click="updateCdxUserDetail(user)">
                {{ user.mobile ? user.mobile : "--" }}
              </td>

              <td @click="updateCdxUserDetail(user)">
                {{
                  user.user_hotel
                    ? user.user_hotel.name
                      ? user.user_hotel.name
                      : "-"
                    : "-"
                }}
              </td>
              <td>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="user.is_active"
                    @click="
                      statusChange(user.id, {
                        is_active: !user.is_active,
                      })
                    "
                  />
                </div>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <i
                    v-b-popover.hover="'Edit'"
                    class="fas fa-pencil-alt text-success"
                    @click="updateCdxUserDetail(user)"
                  ></i>
                  <i
                    v-b-popover.hover="'Delete'"
                    class="mdi mdi-trash-can text-danger fs-5 ms-2"
                    @click="deleteCdxUser(user.id, index)"
                  ></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>

    <Drawer
      @close="UserForm"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="isShowUserForm">
        <CdxUserDetails
          :userDetails="this.selectedUser"
          :isEdit="this.isEdit"
          @cancelSubmit="UserForm"
          @submitted="handleUserSubmit"
        />
      </div>
    </Drawer>
  </div>
</template>

<style scoped>
.w-250 {
  width: 250px;
}
</style>
